<div class="wrapper">
    <h1>Add Your School</h1>
    <button (click)="closeModal()" aria-label="Close" class="close" type="button">
        <i class="pbslm-close-thin-cross close-img"></i>
    </button>
    <div class="information-box">
        <div class="note">
            Help us improve our list of schools in the country. If you think your school is not in
            our list yet, please add it here.
        </div>
        <app-input-box [(inputModel)]="suggestedSchool.name" label="School Name *"></app-input-box>
        <app-error-message *ngIf="!suggestedSchool.name && isSubmitted"></app-error-message>
        <app-input-box
            [(inputModel)]="suggestedSchool.zipCode"
            label="School Zip Code *"
        ></app-input-box>
        <app-error-message *ngIf="!suggestedSchool.zipCode && isSubmitted"></app-error-message>
        <div class="address">
            <app-input-box [(inputModel)]="suggestedSchool.address" label="Address"></app-input-box>
            <div class="city-input-wrapper">
                <app-input-box [(inputModel)]="suggestedSchool.city" label="City"></app-input-box>
            </div>
        </div>
        <div class="required-note">* Required fields</div>
        <div class="submit-button">
            <app-button (click)="handleData()">Submit</app-button>
        </div>
    </div>
</div>
